import { PureComponent, useEffect, useState } from "react";
import { PlanProps } from "../../types";
import {
    BarChart, Bar, XAxis, YAxis, CartesianGrid,
    ResponsiveContainer, ReferenceLine
} from 'recharts';

interface ChartDataTypes {
    id: string;
    value: number;
    label: string;
}

export const RateCompare = ({ marketAvg, product }: {
    marketAvg: string;
    product: PlanProps | undefined
}) => {
    const [chartData, setChartData] = useState<ChartDataTypes[]>([]);

    useEffect(() => {
        if (!product || !product) return;

        setChartData([{
            id: '0',
            value: Number(parseFloat(product.price1000).toFixed(2)),
            label: 'Clean Sky Energy'
        }, {
            id: '1',
            value: parseFloat(marketAvg),
            label: 'Average'
        }
        ])
    }, [marketAvg, product])
    
    if (!chartData) return null;

    return (
        <>
            <div style={{ height: 130 }}>
                <ResponsiveContainer>
                    <BarChart
                        data={chartData}
                        margin={{ top: 30, bottom: 20 }}

                    >
                        <XAxis dataKey="id" stroke="#bbb" tick={<CustomizedTick />} />
                        <YAxis
                            hide={true}
                            domain={['dataMin -1', 'dataMax']}
                        />
                        <CartesianGrid vertical={false} strokeDasharray="2" />
                        <Bar dataKey="value"
                            isAnimationActive={true}
                            maxBarSize={80}
                            shape={BarWithTopBorder()}
                            animationDuration={2000}
                            label={<CustomizedLabel />}
                        />
                        {
                            chartData[0] &&
                            <ReferenceLine
                                y={chartData[0].value}
                                stroke="#2372B9"
                                strokeDasharray="5 3"
                                strokeWidth={1}
                            />
                        }
                    </BarChart>
                </ResponsiveContainer>
            </div>
            <p style={{ fontSize: 12, color: '#999' }} className="text-center mb-0">{`Market average rate based on ${product?.contract_term} month term at 1,000 kWh per month in Centerpoint TDU`}</p>
        </>
    )
}


const BarWithTopBorder = () => {
    return function topBorder(props: any) {
        const { x, y, width, height, id } = props;

        let isHost = id === '0' ? true : false;
        return (
            <g className={`bar-cell ${isHost ? 'special' : ''}`}>
                <rect x={x} y={y} width={width} height={height} stroke="none" className="bar" rx="2" ry="2" />
                <rect x={x} y={y} width={width} height={3} stroke="none" className="bar-top" rx="2" ry="2" />
            </g>
        )
    }
}

class CustomizedTick extends PureComponent {
    render() {
        const { x, y, payload, width, visibleTicksCount }: Readonly<any> = this.props;
        const maxWidth = 100;
        const _width = width / visibleTicksCount > maxWidth ? maxWidth : width / visibleTicksCount;
        if (payload.value === 0 || payload.value === 'auto') return null;

        return (
            <g transform={`translate(${x},${y})`}>
                {
                    payload.value === '0' ?
                        <image
                            x={_width / 2 * -1}
                            y={2}
                            xlinkHref={`/images/logo.png`}
                            width={_width}
                        /> :
                        <text
                            x={-20}
                            y={17}
                            fill='#666'
                            fontSize={14}
                        >Average</text>
                }
            </g>
        )
    }
}

class CustomizedLabel extends PureComponent {
    render() {
        const { x, y, value, width }: Readonly<any> = this.props;
        return (
            <text
                x={x + width / 2}
                y={y}
                dy={-8}
                fill='#3a3a3a'
                fontSize={width / 5}
                fontWeight="700"
                textAnchor="middle"
            >
                {value}¢
            </text>
        )
    }
}